<template>
	<div class="cardItems">
		<div class="cardItems_inner">
			<div class="cardItems_title">{{ title }}</div>
			<p class="cardItems_lead" v-html="lead"></p>
			<CardItem
				class="is-reverse"
				cardTitle="ビジネスプラットフォーム領域"
				cardDesc="最上流から、現場の定着まで。<br>「世界標準」の技術で、<br>クライアントをリードする。"
				pageLink="/business_platform"
				:contentsImage="require('../../assets/home/cardImg01.jpg')"
			/>
			<CardItem
				cardTitle="エンベデッド領域"
				cardDesc="ソフトウェア開発支援だけではなく、<br>技術者の育成・<br class='over_display'>スキルアップも手掛ける。"
				pageLink="/embedded"
				:contentsImage="require('../../assets/home/cardImg02.jpg')"
			/>
			<CardItem
				class="is-reverse"
				cardTitle="ロボット領域"
				cardDesc="メカ・エレキ・ソフトを自社で<br class='under_display'>一貫して開発。<br>プロジェクトは90%が新規開発案件。"
				pageLink="/robot"
				:contentsImage="require('../../assets/home/cardImg03.jpg')"
			/>
			<CardItem
				cardTitle="DX・AIソリューション領域"
				cardDesc="企業のデジタル変革、<br>事業創発を伴走型で支援する。"
				pageLink="/dxai_solution"
				:contentsImage="require('../../assets/home/cardImg04.jpg')"
			/>
		</div>
	</div>
</template>

<script>
import CardItem from './CardItem.vue';
export default {
	name: 'card-items',
	components: {
		CardItem,
	},
	props: {
		title: String,
		lead: String,
	},
};
</script>

<style lang="scss">
.cardItems {
	font-family: 'Noto Serif JP';
	overflow: hidden;
	margin-bottom: 150px;
	&_inner {
		position: relative;
		z-index: 10;
		margin: 0 auto;
		max-width: 1160px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 80px 0;
		// border: 2px solid #543193;
		max-width: 1140px;
		border-bottom: 3px solid #543193;
		@media print, screen and (max-width: 1160px) {
			border-bottom: 2px solid #543193;
			padding: 90px 1.5em 50px;
			max-width: 90%;
		}
		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: calc(100% - 2px);
			height: 100%;
			border: 2px solid #543193;
			z-index: 1;
			pointer-events: none;
			@media print, screen and (min-width: 1161px) {
				width: calc(100% - 3px);
				border-width: 3px;
			}
		}
	}
	&_title {
		display: inline-block;
		position: absolute;
		top: 0;
		right: -2px;
		margin: 0 0 0 auto;
		font-family: 'Noto Serif JP';
		background-color: #543193;
		color: #fff;
		padding: 0.5em 2.5em;
		@media print, screen and (min-width: 1161px) {
			right: -3px;
			padding: 0.7em 3.5em;
			font-size: 18px;
		}
	}
	&_lead {
		text-align: center;
		font-size: 16px;
		line-height: calc(41 / 16);
		letter-spacing: 0;
		margin-top: 0;
		@media print, screen and (max-width: 1160px) {
			font-size: 15px;
			line-height: calc(73 / 29);
		}
		@media print, screen and (max-width: 520px) {
			text-align: left;
		}
	}
}
</style>
